// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
// If you want to change the content of this file, you need to edit
// file '/dictionaries/ru.po' and run '.po' extractor
import { base } from './base';

export const ru = { ...base };
